<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! No Monitoramento do Coeficiente de Desempenho do Servidor (CDS) você encontra duas
        abas:
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          1. <b>CDS dos servidores</b><br>
          2. <b>Relatórios Gerenciais por unidades</b>
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. CDS dos servidores
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“CDS dos servidores”</b> você encontra três tipos de
          filtros: <br>
          1. <b>Unidade</b><br>
          2. <b>Categoria</b><br>
          3. <b>Servidor</b>
        </p>

        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro <b>“Unidade”</b> você encontra a sua unidade. No filtro <b>“Categoria”</b>
          você faz a seleção entre: gestor, servidor ou todas. No filtro <b>“Servidor”</b> você
          encontra os servidores da unidade, de acordo com a categoria selecionada.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Ao selecionar um servidor será possível analisar, por meio de gráficos e tabelas,
          os dados referentes ao desempenho técnico e comportamental em conjunto, no ano em análise.
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. CDS dos servidores<br>
        Gráficos e tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No primeiro gráfico é apresentada a matriz de desempenho comportamentos x responsabilidade.
          Na área da matriz o servidor selecionado encontra-se posicionado de acordo com as notas
          obtidas no desempenho comportamental e técnico.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          O velocímetro expressa o resultado do CDS obtido pelo servidor, com a seguinte fórmula:
        </p>
        <p class="mx-2 pa-2 text-center font-weight-medium text-lg-h6">
          (nota comportamental x nota responsabilidades)/10
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela “Resultado” é possível observar a descrição das notas obtidas pelo servidor e o seu CDS.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Para melhor interagir com a tabela, pode-se utilizar os recursos de ordenação de forma
          crescente ou decrescente por: servidor, resultado comportamental, resultado técnico e CDS.
          Filtrar por situação: atende, em desenvolvimento e não atende. E, por fim, é possível pesquisar
          por qualquer termo exibido na tabela.
        </p>
      </div>
    </div>

    <div>
      <h2>
        3. Relatórios gerenciais por unidade
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Relatórios gerenciais por unidade”</b> você encontra o filtro “Unidade”.
          Ao selecionar uma unidade, é possível analisar, por meio de gráficos e tabelas, dados conjuntos da
          unidade.
        </p>
        <p class="mx-2 pa-2 text-center font-weight-bold text-lg-h6">
          Gráficos e tabelas
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          O gráfico de pizza apresenta a distribuição dos servidores da unidade nas categorias: atende, em
          desenvolvimento e não atende.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          A tabela traz a relação de servidores, o resultado do CDS de cada um e a categoria do seu CDS. É
          possível observar a média e o desvio padrão dos CDS dos servidores da unidade.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Ao final, apresenta-se a relação de servidores que tiveram o CDS inviabilizado por falta de resultado
          comportamental ou técnico.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba <b>1. “CDS dos Servidores”</b> para analisar o CDS de cada servidor.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba <b>3. “Relatórios gerenciais por unidade”</b> para analisar o resultado
              conjunto dos CDS dos servidores da unidade e verificar se houve casos de CDS inviabilizados.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              O Gestor pode trabalhar os dados expostos, por meio dos gráficos e tabelas, com sua equipe no intuito de
              verificar as categorias: atende, em desenvolvimento, não atende e direcionar ações para o reconhecimento
              do servidor ou para seu desenvolvimento. Todos os resultados podem auxiliar o processo de sucessão do
              gestor da unidade.
            </p>
          </li>
          <!-- <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Você pode imprimir todos os resultados na opção de baixar PDF.
            </p>
          </li> -->
        </ul>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoCoeficienteDesempenhoUnidade',

  components: { BaseTutorial },

  data() {
    return {
      steps: [
        'Introdução',
        'CDS dos servidores',
        'CDS dos servidores',
        'Relatórios gerenciais por unidade',
        'Importante',
      ],
    };
  },
};
</script>
